::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 0.3rem;
}

:root.t_light ::-webkit-scrollbar-thumb {
  background: var(--c-unistocksLight);
}

:root.t_light ::-webkit-scrollbar-track {
  background: #fdfdfd;
}

:root.t_dark ::-webkit-scrollbar-thumb {
  background: var(--headingFont);
}

:root.t_dark ::-webkit-scrollbar-track {
  background: var(--background);
}

body {
  &.overflow-hidden {
    overflow: hidden;
  }
}
